import moment from "moment";
import format from "string-template";
import { isMajor } from "utils/helpers/date";
import * as yup from "yup";

const MAX_CHILD_AGE = 25;

const validation = (errors) => {
  const childAgeError = format(errors.CHILD_AGE_MAX, { age: MAX_CHILD_AGE });
  const requiredString = yup
    .string()
    .typeError(errors.REQUIRED)
    .required(errors.REQUIRED);
  return yup.object().shape({
    spouse: yup
      .object()
      .shape({
        identity: yup.object().shape({
          user: yup.object().shape({
            birthDate: yup
              .date()
              .typeError(errors.REQUIRED)
              .max(isMajor, errors.RADIANCE.SPOUSE_AGE)
              .min(
                moment().subtract(100, "year").startOf("year"),
                errors.RADIANCE.SPOUSE_AGE,
              )
              .required(errors.REQUIRED),
          }),
          socialRegime: requiredString,
        }),
      })
      .nullable()
      .default(undefined),
    children: yup.array().of(
      yup.object().shape({
        identity: yup.object().shape({
          user: yup.object().shape({
            birthDate: yup
              .date()
              .typeError(errors.REQUIRED)
              .min(
                moment().subtract(MAX_CHILD_AGE, "year").startOf("year"),
                childAgeError,
              )
              .max(moment(), childAgeError)
              .required(errors.REQUIRED),
          }),
          socialRegime: requiredString,
        }),
      }),
    ),
  });
};

export default validation;
